// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__0tid6","spin":"Loader_spin__Hm8Ar","sm":"Loader_sm__kP-04","md":"Loader_md__z9e8A","lg":"Loader_lg__vdNkH"};